import classnames from 'classnames/bind';
import styles from './index.module.less';

const cx = classnames.bind(styles);
export const SectionTitle = ({
  children,
  sub,
  className,
}: {
  children: React.ReactNode;
  sub?: string;
  className?: string;
}) => {
  return (
    <hgroup className={className}>
      <h1 className={cx('section-title')}>{children}</h1>
      {sub && <h2 className={cx('section-sub')}>{sub}</h2>}
    </hgroup>
  );
};
